//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Routing.js";
import "../Preferences/Preferences.RoutingPart.js";
let d=[[],[[[],"GetRoot",{R_:{root:''}},0,0],[["root_type"],"GetFilteredRoot",{R_:{root:''}},1,0],[["parent","num_children"],"GetChildrenNodes",{R_:{children:""}},1,0],[["node"],"GetNodeType",{R_:{type:''}},1,0],[["node","num_columns"],"GetTableDefinition",{R_:{columns:""}},1,0],[["node"],"GetPartDefinition",{R_:{part_def:"Routing.CharacteristicList"}},1,0],[[],"CreateCriteria",{R_:{criteria:"Routing.CharacteristicList"}},0,0],[["start_node","criteria","num_matches"],"MatchCriteria",{R_:{matches:"Routing.CharacteristicList[]"}},2,0],[["start_node","criteria","num_matches"],"MatchCriteriaWithFilter",{R_:{matches:"Routing.CharacteristicList[]"}},2,0],[["match","part_classes"],"FilterOnCurrentSpecifications",{R_:{is_valid:''}},2,0]],[]];
SPLM.Preferences.RoutingPartLibrary = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingPartLibrary";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingPartLibrary.Column = class{
    constructor(name,hidden,type){
        this.name=name;this.hidden=hidden;this.type=type;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Hidden(){return this.hidden}
    set Hidden(val){this.hidden = val}
    get Type(){return this.type}
    set Type(val){this.type = val}
};

SPLM.Preferences.RoutingPartLibrary.NodeType = Object.freeze({
    "Normal" : "Normal", "Table" : "Table", "Part" : "Part"});

SPLM.Preferences.RoutingPartLibrary.ColumnType = Object.freeze({
    "Integer" : "Integer", "Real" : "Real", "String" : "String"});

SPLM.Preferences.RoutingPartLibrary.RootType = Object.freeze({
    "Top" : "Top", "Stock" : "Stock", "Wire" : "Wire", "Part" : "Part"});

SPLM.Preferences.RoutingPartLibrary.ColumnStatus = Object.freeze({
    "NotHidden" : "NotHidden", "Hidden" : "Hidden"});

export default SPLM;